import React from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import styles from '../../styles.less';
import geoHierarchyLevels from '../../geoHierarchyLevels';
import LoadingStatus from '../LoadingStatus/LoadingStatus.jsx';
import DemographicInfoWidget from '../DemographicInfo/Widget/Widget.jsx';
import DemographicInfoWidgetPlaceholder from '../DemographicInfo/Placeholder/Placeholder.jsx';
import { getActiveTab, navigateTo, TAB } from '../Navigation/Menu/menuConfig';
import PriceHistoryWidget from '../PriceHistory/Widget/Widget.jsx';
import PriceCheckWidget from '../PriceCheck/Widget/Widget.jsx';
import PriceCheckWidgetPlaceholder from '../PriceCheck/Widget/Placeholder/Placeholder.jsx';
import PriceHistoryWidgetPlaceholder from '../PriceHistory/Widget/Placeholder/Placeholder.jsx';
import {
  getAddress,
  getAddressStatus,
  getAddressTitleAndSubtitle,
  getDemographicInfoStatus,
  getGeoHierarchy,
  getGeoHierarchyStatus,
  getHierarchyLevel,
  getPriceHistory,
  getPriceHistoryStatus,
  getPricesPerQuarterDashboard,
  getPricesPerYearDashboard,
  getRealEstateType,
  getSubHierarchyLinks,
  getSubHierarchyLinksStatus,
  getUserIntent,
} from '../../selectors/selectors.js';
import ErrorBoundary from '../Utils/ErrorBoundary/ErrorBoundary.jsx';
import Header from '../Header/Header.jsx';
import AtlasTouchpointWrapper from '../AtlasTouchpointWrapper/AtlasTouchpointWrapper.jsx';
import titleExtractor from '../../utils/titleExtractor';
import SubHierarchyInfoWidget from '../SubHierarchyInfoWidget/SubHierarchyInfoWidget.jsx';
import RealEstatePreviewWidget from '../RealEstatePreviewWidget/RealEstatePreviewWidget.jsx';
import realEstateTypes from '../../realEstateTypes';
import HomeOwnerWorldTeaser from '../HomeOwnerWorldTeaser/HomeOwnerWorldTeaser';
import HeaderBreadcrumb from '../Header/Breadcrumb/Breadcrumb';
import HeaderTitle from '../Header/Title/Title';
import CampaignParametersDashboard from '../Utils/Touchpoint/CampaignParametersDashboard';
import NewNavigationHeader, {
  VIEW_TYPE_OLD_DASHBOARD
} from "../Navigation/Header/NewNavigationHeader";
import { withLocation, withNavigate } from "../../utils/router";
import { PRICE_OVERVIEW_PROMO_OLD_TO_HOMEOWNER_LANDINGPAGE_URL } from "../MyPropertyRelocation/urls";
import NewStaticMapWidget from "../StaticMapWidget/NewStaticMapWidget";

const DashboardWidget = ({ statuses, placeHolder, render, widthClasses }) => (
  <div className={`grid-item ${widthClasses}`}>
    <ErrorBoundary>
      <LoadingStatus status={statuses || []} renderLoader={placeHolder}>
        {render}
      </LoadingStatus>
    </ErrorBoundary>
  </div>
);

const shareOfVoiceWidgetGeoLevels = [
  geoHierarchyLevels.ADDRESS,
  geoHierarchyLevels.STREET,
  geoHierarchyLevels.DISTRICT,
  geoHierarchyLevels.CITY,
  geoHierarchyLevels.REGION,
];
const shareOfVoiceRealEstateTypes = [realEstateTypes.APARTMENT_BUY, realEstateTypes.HOUSE_BUY];

export class Dashboard extends React.Component {
  isTabVisible = (tabId) => getActiveTab(this.props.location.pathname) === tabId;

  renderHeader() {
    return <Header />;
  }

  renderPriceHistoryWidget = () => {
    const { realEstateType, navigate, addressTitle, pricesPerQ, pricesPerYear, hierarchyLevel } = this.props;

    return (
      <PriceHistoryWidget
        hierarchyLevel={hierarchyLevel}
        address={addressTitle}
        realEstateType={realEstateType}
        pricesPerQ={pricesPerQ}
        pricesPerYear={pricesPerYear}
        onButtonClicked={() => navigateTo(navigate, TAB.priceHistory)}
      />
    );
  };

  render() {
    const {
      priceHistoryStatus,
      addressStatus,
      geoHierarchyStatus,
      demographicInfoStatus,
      subHierarchyLinkStatus,
      subHierarchyLinks,
      hierarchyLevel,
      userIntent,
      geoHierarchy,
      address,
      realEstateType,
    } = this.props;

    const titleData = titleExtractor(hierarchyLevel, geoHierarchy, address);
    const isAddressLevel = hierarchyLevel === geoHierarchyLevels.ADDRESS;
    const isStreetLevel = hierarchyLevel === geoHierarchyLevels.STREET;

    return (
      <>
        <div className={`${styles.headerContainerWithMyPropertyFeature} grid-item one-whole`}>
          {this.renderHeader()}
        </div>
        <div className="grid grid-flex grid-align-stretch padding-bottom-xxl gutter-l padding-horizontal-l">
          <div className={`grid-item one-whole  ${styles.newHeaderContainer}`}>
            <HeaderBreadcrumb breadcrumbItems={geoHierarchy} hierarchyLevel={hierarchyLevel} />
            <HeaderTitle
              userIntent={isAddressLevel || isStreetLevel ? null : userIntent}
              text={titleData.title}
              subText={titleData.subTitle}
            />
          </div>
          <DashboardWidget
            statuses={['DONE']}
            placeHolder={() => <div />}
            render={() => (
              <HomeOwnerWorldTeaser onButtonClicked={() => window.location = PRICE_OVERVIEW_PROMO_OLD_TO_HOMEOWNER_LANDINGPAGE_URL} />
            )}
            widthClasses={`one-whole ${
              isAddressLevel ? styles.myPropertyContainerAddressLevel : styles.myPropertyContainer
            }`}
          />

          <DashboardWidget
            render={() => <NewNavigationHeader viewType={VIEW_TYPE_OLD_DASHBOARD} groupName={'OldDashboard'} />}
            widthClasses="one-whole"
          />

          <DashboardWidget
            statuses={[addressStatus]}
            placeHolder={() => <PriceCheckWidgetPlaceholder />}
            render={() => <PriceCheckWidget />}
            widthClasses="one-whole desk-one-half"
          />
          <DashboardWidget
            statuses={[priceHistoryStatus, addressStatus]}
            placeHolder={() => <PriceHistoryWidgetPlaceholder />}
            render={this.renderPriceHistoryWidget}
            widthClasses="one-whole desk-one-half"
          />
          <DashboardWidget
            render={() => <NewStaticMapWidget isNewPageConcept={false} />}
            widthClasses="one-whole"
          />
          {shareOfVoiceWidgetGeoLevels.indexOf(hierarchyLevel) !== -1 &&
            shareOfVoiceRealEstateTypes.indexOf(realEstateType) !== -1 &&
            this.isTabVisible(TAB.home.id) && (
            <DashboardWidget
              statuses={[addressStatus, geoHierarchyStatus, priceHistoryStatus]}
              render={() => <AtlasTouchpointWrapper campaignParams={CampaignParametersDashboard} />}
              widthClasses="one-whole"
            />
          )}
          {(isAddressLevel || isStreetLevel) && (
            <DashboardWidget
              statuses={[addressStatus, demographicInfoStatus, geoHierarchyStatus]}
              placeHolder={() => <DemographicInfoWidgetPlaceholder />}
              render={() => <DemographicInfoWidget />}
              widthClasses="one-whole"
            />
          )}
          <DashboardWidget
            statuses={[addressStatus, geoHierarchyStatus, priceHistoryStatus]}
            render={() => <RealEstatePreviewWidget />}
            widthClasses="one-whole"
          />
          {!isAddressLevel && (
            <DashboardWidget
              statuses={[subHierarchyLinkStatus]}
              render={() => (
                <SubHierarchyInfoWidget hierarchyLevel={hierarchyLevel} subHierarchyLinks={subHierarchyLinks} />
              )}
              widthClasses="one-whole"
            />
          )}
        </div>
      </>
    );
  }
}

Dashboard.propTypes = {
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  addressStatus: getAddressStatus(state),
  address: getAddress(state),
  geoHierarchyStatus: getGeoHierarchyStatus(state),
  geoHierarchy: getGeoHierarchy(state),
  priceHistory: getPriceHistory(state),
  priceHistoryStatus: getPriceHistoryStatus(state),
  realEstateType: getRealEstateType(state),
  hierarchyLevel: getHierarchyLevel(state),
  demographicInfoStatus: getDemographicInfoStatus(state),
  subHierarchyLinkStatus: getSubHierarchyLinksStatus(state),
  subHierarchyLinks: getSubHierarchyLinks(state),
  pricesPerQ: getPricesPerQuarterDashboard(state),
  pricesPerYear: getPricesPerYearDashboard(state),
  addressTitle: getAddressTitleAndSubtitle(state).title,
  userIntent: getUserIntent(state),
});

export default withLocation(withNavigate(connect(mapStateToProps)(Dashboard)));
